import { I18n } from "@assets/strings";
import React from "react";
import { Link } from "react-router";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path, linkDescriptor } from "@core/routing/path";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { DetailedCourse } from "@domain/lms/course/course";
import { useMyFeedback } from "@domain/lms/course/hooks";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { ScrollBehavior } from "@ui/components/navigation/scrollToTop";
import { useModalTools } from "@ui/modals/modalContext";
import { gap } from "@ui/styles/utils";
import { FeedbackModal } from "@ui/pages/lms/coursePage/feedback/feedbackModal";

interface CourseNavigationProps extends React.HTMLAttributes<HTMLDivElement> {
	chapterIndex: number;
	course: DetailedCourse;
	onFinish: () => void;
}

export const CourseNavigation: React.FC<CourseNavigationProps> = ({ chapterIndex, course, onFinish, ...htmlProps }) => {
	const lastPage = chapterIndex >= course.content.chapters.size - 1;
	const firstPage = chapterIndex === 0;
	const { createModal } = useModalTools();
	const currentProfile = useCurrentProfile();
	const isAuthor = course.author?.id === currentProfile?.id;
	const history = useHistory();

	const { result: myFeedback } = useMyFeedback(course.id);

	return (
		<Container {...htmlProps} center={firstPage && !lastPage}>
			{!firstPage && (
				<Link to={linkDescriptor(Path.Lms.CourseContent(course.id, chapterIndex - 1))} state={ScrollBehavior.Scroll}>
					<SecondaryButton>{I18n.t("previous")}</SecondaryButton>
				</Link>
			)}
			{lastPage ? (
				<PrimaryButton
					onClick={() => {
						onFinish();
						// setTimeout(() => {
						// 	history.push(Path.Lms.Course(course.id));
						// 	!isAuthor && createModal((close) => <FeedbackModal close={close} course={course} />);
						// }, 200);
						history.push(Path.Lms.ReferenceCourse(course));
						if (!isAuthor && !myFeedback) {
							createModal((close) => <FeedbackModal close={close} course={course} />);
						}
					}}
				>
					{I18n.t("finish")}
				</PrimaryButton>
			) : (
				<Link to={linkDescriptor(Path.Lms.CourseContent(course.id, chapterIndex + 1))} state={ScrollBehavior.Scroll}>
					<PrimaryButton>{I18n.t("next")}</PrimaryButton>
				</Link>
			)}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "center",
})<{ center?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	${gap(20, "row")};

	@media (max-width: 900px) {
		${gap(0, "row")};
		justify-content: ${({ center }) => (center ? "center" : "space-between")};
	}
`;
